import React from "react";
import { Link } from "react-router-dom";
import type { LucideIcon } from "lucide-react";
import { cn } from "../../helpers/cn";

// Shared by the link rows and the group header button so the two stay in lockstep.
// Tokens mirror Button's `secondary` variant; the ring colour is set explicitly
// because Button's base declares ring-2 without one.
export const NAV_ROW_BASE =
  "flex items-center gap-3 h-10 px-4 rounded-full font-medium transition-colors " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2";

// 46px = px-4 (16) + icon (18) + gap-3 (12), so sub-labels align under group labels.
const SUB_ROW_BASE =
  "flex items-center h-9 pl-[2.875rem] pr-4 rounded-full text-sm transition-colors " +
  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2";

interface AdminNavLinkProps {
  to: string;
  label: string;
  isActive: boolean;
  variant: "top" | "sub";
  icon?: LucideIcon;
}

export const AdminNavLink: React.FC<AdminNavLinkProps> = ({
  to,
  label,
  isActive,
  variant,
  icon: Icon,
}) => (
  <Link
    to={to}
    aria-current={isActive ? "page" : undefined}
    className={cn(
      variant === "top" ? NAV_ROW_BASE : SUB_ROW_BASE,
      variant === "top"
        ? "text-black hover:bg-primary-100"
        : "text-gray-800 hover:bg-primary-100 hover:text-primary",
      isActive && "bg-primary-300 text-primary",
      isActive && variant === "sub" && "font-medium"
    )}
  >
    {Icon && (
      <Icon
        className="w-[18px] h-[18px] shrink-0"
        strokeWidth={1.75}
        aria-hidden="true"
        focusable="false"
      />
    )}
    <span className="truncate">{label}</span>
  </Link>
);
